var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M2.74967 4.67399L9.87412 10.2152C10.5362 10.7301 11.4632 10.7301 12.1252 10.2152L19.2497 4.67399M4.76634 18.424H17.233C18.2598 18.424 18.7732 18.424 19.1653 18.2242C19.5103 18.0484 19.7908 17.7679 19.9665 17.423C20.1663 17.0308 20.1663 16.5174 20.1663 15.4907V6.69066C20.1663 5.66389 20.1663 5.15051 19.9665 4.75834C19.7908 4.41338 19.5103 4.13291 19.1653 3.95715C18.7732 3.75732 18.2598 3.75732 17.233 3.75732H4.76634C3.73958 3.75732 3.2262 3.75732 2.83403 3.95715C2.48906 4.13291 2.2086 4.41338 2.03283 4.75834C1.83301 5.15051 1.83301 5.66389 1.83301 6.69066V15.4907C1.83301 16.5174 1.83301 17.0308 2.03283 17.423C2.2086 17.7679 2.48906 18.0484 2.83403 18.2242C3.2262 18.424 3.73958 18.424 4.76634 18.424Z",
    stroke: "#2E2E2E",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.a6100c16dea6ef8c5369587a315904cf.svg";
export { ForwardRef as ReactComponent };